<template>
    <div>
        <div v-if="loading" class="spinner" ></div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-user"></i> -->
                    <input v-model="template.title" class="form__input--text" type="text" :class="{ 'has-value': template.title }"/>
                    <label class="form__label">{{$t('forms.survey_template.title')}}</label>
                </div>
                <div v-if="!template.id" class="form__item">
                    <!-- <i class="form__icon icons icon-graduation"></i> -->
                    <vue-select label="title" :options="templateTypes" v-model="template.type" class="form__select" :class="{ 'has-value': template.type }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.survey_template.type')}}</label>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import SurveyTemplate from '@/models/SurveyTemplate';

    import { SURVEY_TEMPLATE_TYPES, SAVE_SURVEY_TEMPLATE } from '@/store/modules/survey-template';


    @Component
    export default class SurveyTemplateForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: SurveyTemplate, default() {
            return new SurveyTemplate();
        } })
        template;

        errors = [];

        created() {
            this.errors = [];
        }

        get isSaveDisabled() {
            return !this.template.title;
        }

        get loading () {
            return this.saveLoading;
        }

        get templateTypes() {
            return SURVEY_TEMPLATE_TYPES.map(type => {
                return {value: type, title: this.$t('forms.survey_template.types.' + type)};
            });
        }

        save() {
            this.errors = [];
            this.$store.dispatch(SAVE_SURVEY_TEMPLATE, { template: this.template })
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/survey-templates/SurveyTemplateForm.vue